import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import metadata from 'libphonenumber-js/min/metadata';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { maskitoPhoneOptionsGenerator } from '@maskito/phone';

import { IPickupOwner } from '../../../lib/lib-shared/models/PickupOwner';
import { PickupOwnerAdvertising } from '../../../lib/lib-shared/types/PickupOwnerAdvertising';
import { PhoneNumberValidator } from '../../utils/phone-number-validator';
import { IPickupOwnerModalOutput } from './pickup-owner-modal.component.types';

@Component({
  selector: 'app-pickup-owner-modal',
  standalone: false,
  templateUrl: './pickup-owner-modal.component.html',
  styleUrl: './pickup-owner-modal.component.scss'
})
export class PickupOwnerModalComponent implements OnInit {
  @ViewChild('tagNumberInput') phoneNumberInput!: ElementRef;
  readonly phoneMask = maskitoPhoneOptionsGenerator({
    metadata,
    strict: false,
    separator: ' ',
  });
  public pickupOwnerForm!: FormGroup;

  public pickupOwner: IPickupOwner | null = null;
  public isPickupMode = false;

  readonly colorOptions = [
    {value: PickupOwnerAdvertising.RED, label: 'Rouge (Express/Utile/Contact/City)', desc: '1 A4 draps + 1 A4 couette + 1 A2 couette + 1 A2 draps'},
    {value: PickupOwnerAdvertising.GREEN, label: 'Vert (Super)', desc: '2 A4 couette + 2 A4 draps + 1 A2 couette + 1 A2 draps + 1 A1 draps + 1 A1 couette'},
    {value: PickupOwnerAdvertising.BLUE, label: 'Bleu (Drive)', desc: '2 A4 couette + 2 A4 draps + 1 A1 couette + 1 A1 draps + 1 A0 draps + 1 A0 couette'},
    {value: PickupOwnerAdvertising.YELLOW, label: 'Jaune (Hyper)', desc: '2 A4 couette + 2 A4 draps + 1 A1 couette + 1 A1 draps + 1 A0 draps + 1 A0 couette'},
  ];

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.pickupOwnerForm = this.fb.group({
      advertisingEnabled: [this.pickupOwner ? !!this.pickupOwner.advertising : false],
      advertisingColor: [this.pickupOwner?.advertising ?? PickupOwnerAdvertising.RED],
      firstName: [this.pickupOwner ? this.pickupOwner.firstName : '', Validators.required],
      lastName: [this.pickupOwner ? this.pickupOwner.lastName : '', Validators.required],
      email: [this.pickupOwner ? this.pickupOwner.email : '', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$'),]],
      phoneNumber: [this.pickupOwner ? this.pickupOwner.phoneNumber : '+33', [Validators.required, PhoneNumberValidator()]],
    });
  }

  onValidate() {
    const pickupOwner: IPickupOwnerModalOutput = {
      sticker: false,
      ...this.pickupOwnerForm.value.advertisingEnabled && {advertising: this.pickupOwnerForm.value.advertisingColor},
      firstName: this.pickupOwnerForm.value.firstName,
      lastName: this.pickupOwnerForm.value.lastName,
      email: this.pickupOwnerForm.value.email,
      phoneNumber: this.pickupOwnerForm.value.phoneNumber,
    };

    this.activeModal.close(pickupOwner);
  }
}
